<template src="./templatesListComponent.template.html"></template>
<script>
export default {
  name: "templatesList",
  data() {
    return {
      templatesList: [],
      statusId: 1,
      statusList: [],
      showlabel: false,
      templateSearch: ""
    };
  },
  methods: {
    splitJoin(theText) {
      return theText.split(",");
    },

    Searchtext(value) {
      let vm = this;
      console.log("valueeeeeeeeeee", value);
      vm.Get_TemplatesList();
    },
    clearTemplateSearch() {
      let vm = this;
      vm.templateSearch = "";
      vm.Get_TemplatesList();
    },

    Get_TemplatesList() {
      
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "Get_TemplatesList",
        params: {
          ModuleAction: "Get_TemplatesList",
          StatusId: vm.statusId,
          SearchText: vm.templateSearch
        },

        callback: function(err, response) {
          if (err) {
            console.log("err in Get_TemplatesList", err);
            return;
          }
          if (response) {
            console.log("response in Get_TemplatesList", response);
            if (response[0]) {
              vm.templatesList = response[0];
            }
            if (vm.templatesList.length == 0) {
              vm.showlabel = true;
            } else {
              vm.showlabel = false;
            }
          }
        }
      });
    },
    getPropertyMetaData: function() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetPropertiesBySearchText",
        params: {},
        callback: function(err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log("GetPropertiesBySearchText==>", response);
            //   vm.propertyList.splice(0, vm.propertyList.length, ...response.propertyList);
            vm.statusList.splice(
              0,
              vm.statusList.length,
              ...response.statusList
            );
          }
        }
      });
    },
    selectTemplate(template) {
      let vm = this;
      vm.$router.push("/notificationTemplate/" + template.TemplateId);
    }
  },
  computed: {},
  mounted() {
    let vm = this;
    vm.Get_TemplatesList();
    vm.getPropertyMetaData();
  }
};
</script>